import React from "react";

import LogoIcon from "../assets/icons/logo.png";

const Logo = () => {
  return <img src={LogoIcon} alt="logo" height={50} />;
};

export default Logo;
